import React from "react";
import { useEffect } from "react";

const decorOverlayUrl = `/wp-content/themes/teamconnector2/assets/images/decoroverlay.png`;

const ProgressBar = ({ currentRound, totalRound, isDisplayContent }) => {
  const progressBarText = window.progress_bar.progress_bar_text;

  useEffect(() => {});
  return (
    <>
      <div className="v2-progress-bar">
        <div className="v2-progress-bar__decor decorleft">
          <svg
            className="decorBase"
            width="134"
            height="76"
            viewBox="0 0 134 76"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M134 0H97.6372C84.0146 0 74.396 14.0252 63.4228 30.0255C48.8522 51.2715 31.8931 76 0 76H134V0Z"
              fill="currentColor"
            />
          </svg>
          <source srcSet={decorOverlayUrl} type="image/png" />
          <img
            className="decorOverlay"
            src={decorOverlayUrl}
            alt="decor overlay"
          />
        </div>
        <div className="v2-progress-bar__main">
          <div
            className="round-display"
            style={{ display: isDisplayContent ? "" : "none" }}
          >
            <h1>{currentRound}</h1>
            <span className="total-round">/{totalRound}</span>
          </div>
          <div
            className="round-progress-bar"
            style={{ display: isDisplayContent ? "" : "none" }}
          >
            <h3 className="round-progress-bar__title">{progressBarText}</h3>
            <div className="round-progress-bar__box">
              <div
                className={`round-progress-bar__box-item`}
                style={{ width: (currentRound / totalRound) * 100 + "%" }}
              />
            </div>
          </div>
        </div>
        <div className="v2-progress-bar__decor decorright">
          <svg
            className="decorBase"
            width="134"
            height="76"
            viewBox="0 0 134 76"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M134 0H97.6372C84.0146 0 74.396 14.0252 63.4228 30.0255C48.8522 51.2715 31.8931 76 0 76H134V0Z"
              fill="currentColor"
            />
          </svg>
          <source srcSet={decorOverlayUrl} type="image/png" />
          <img
            className="decorOverlay"
            src={decorOverlayUrl}
            alt="decor overlay"
          />
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
